import React from "react";
import "./header.css";
// import img2s from "./img2s.jpg";
import img from "./prPic.jpg";

const Header = () => {
  return (
    <div className="header">
      <div className="leftNav">
        <span className="logo">
          <img src={img} alt="" className="logo-pic" />
          Anshuman Tiwari
        </span>
      </div>
      <div className="rightNav">
        <ul className="navs">
          <li>
            {" "}
            <a href="#projects">Projects</a>{" "}
          </li>
          <li>
            <a href="#about"> About</a>
          </li>
          <li>
            {" "}
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
